const scope = 'containers/GlobalExport/';
export const EXPORT_ITEM = `${scope}EXPORT_ITEM`;
export const SET_EXPORT_LOADING_FLAG = `${scope}SET_EXPORT_LOADING_FLAG`;
export const GET_EXPORT_FILE = `${scope}GET_EXPORT_FILE`;
